module.exports = __webpack_public_path__ + "static/assets/13ed50ee1b8949428d095d27acfee0fb.png";